import { render, staticRenderFns } from "./ButtonClipboard.vue?vue&type=template&id=536e9857&"
import script from "./ButtonClipboard.vue?vue&type=script&lang=js&"
export * from "./ButtonClipboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports